const showcaseWrappers = Array.from(document.querySelectorAll(".we-know-cold-product-showcase-wrapper"));

const collectionsProductSwipers = {};

showcaseWrappers.forEach(showcaseWrapper => {
    const collectionHandle = showcaseWrapper.dataset.collectionHandle;

    const collectionSwiperWrapperSelector = ".we-know-cold-product-showcase-" + collectionHandle;
    const collectionSwiperProgressBarSelector = collectionSwiperWrapperSelector + " .we-know-cold-product-showcase-slider-scrollbar";
  
    initSwiperAfterLibLoad(collectionSwiperWrapperSelector + " .swiper-wrapper-wrapper", {
        // Optional parameters
        direction: "horizontal",
        shortSwipes: true,
        simulateTouch: true,
        slideToClickedSlide: false,
        slidesPerView: "auto",
        slidesPerGroupAuto: true,
        spaceBetween: 24,
        loop: false,
        speed: 500,
        autoHeight: true,
        effect: "slide",
        mousewheel: {
            enabled: true,
            forceToAxis: true,
        },
        allowSlideNext: true,
        allowTouchMove: true,
        // Navigation arrows
        navigation: {
            prevEl: collectionSwiperWrapperSelector + " .slider-back-btn",
            nextEl: collectionSwiperWrapperSelector + " .slider-next-btn",
        },
        scrollbar: {
            el: collectionSwiperProgressBarSelector,
            hide: false,
        },
        on: {
        },
    }).then(result =>  collectionsProductSwipers[collectionHandle] = result);
});